module.exports = __webpack_public_path__ + "static/media/China25-v2.a417000d.jpg";